
import { Grid } from '@material-ui/core';
import Banner from './Banner/Banner';
import Navbar from './Navbar/Navbar';

const Header = () => {

	return (
		<Grid container spacing={0}>
			<Banner />
			<Navbar />
		</Grid>
	)
}
export default Header ;
